import { css } from 'styled-components/macro';

export const aidProfessionalCss = css`
  padding-top: 6rem;
  padding-bottom: 6rem;

  @media (max-width: 962px) {
    padding-top: 0;
    padding-bottom: 5rem;
  }

  @media (max-width: 500px) {
    padding-bottom: 0;
    padding-top: 0;
    margin-top: 0rem;
  }

  h1,
  h2 {
    font-size: 36px;
    font-weight: 700;
    line-height: 44px;

    @media (max-width: 500px) {
      font-size: 30px;
    }

    @media (max-width: 350px) {
      font-size: 25px;
      line-height: 35px;
    }
  }

  p {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;

    @media (max-width: 500px) {
      font-size: 14px;
      line-height: 20px;
    }
    @media (max-width: 350px) {
      font-size: 10px;
    }
  }

  svg {
    width: 100%;

    @media (max-width: 500px) {
      margin-top: -5rem;
      margin-bottom: 0;
      padding-bottom: 0;
    }
    @media (max-width: 350px) {
      margin-top: -8rem;
    }
  }
`;

export const aidButtonsCss = css`
  gap: 1.5rem;
  width: 290px;
  display: flex;
  margin-top: 2rem;
  flex-direction: column;

  @media (max-width: 962px) {
    margin-top: 0;
  }
`;
